<script setup>
import logoBranco from '@/../../resources/img/institucional/Logo_Branco.png'
import CLink from "@/Components/CLink.vue";
import '@fontsource/poppins';
import SocialMediaButton from "@/Pages/Auth/Components/SocialMediaButton.vue"
import CNewsLetter from "@/Components/CNewsLetter.vue";

const mediaLinks = [
    { ico: 'mdi-facebook', src: 'https://www.facebook.com/profile.php?id=61579131811650&locale=pt_BR' },
    { ico: 'mdi-linkedin', src: 'https://www.linkedin.com/company/creative-design_3' },
    { ico: 'mdi-instagram', src: 'https://www.instagram.com/creativedesignbr/' },
    { ico: 'mdi-youtube', src: 'https://www.youtube.com/channel/UComlhLGllvp_WlLj6eJkSiA'}
]
</script>

<template>
    <v-footer class="i-footer bg-institutionalGrey">
        <v-container width="90%">
            <v-row>
                <v-col cols="12" md="8" lg="8" class="d-flex justify-center">
                    <v-row>
                        <!-- Logo -->
                        <v-col cols="12" sm="6" md="6" class="d-flex justify-start i-footer-logo">
                            <c-link ref="router.get(route('institucional.home'))">
                                <v-img :src="logoBranco" width="250" max-width="100%"/>
                            </c-link>
                        </v-col>
                        <!-- Nossa Loja links -->
                        <v-col cols="6" sm="3" md="2" class="d-flex justify-start justify-sm-center ilinks">
                            <p><strong>Comercial</strong>
                                <br/>
                                <CLink :href="route('home')" class="ispace">Catálogo</CLink>
                                <br/>
                                <!-- <CLink :href="route('home')" class="ispace">Promoções</CLink>
                                <br/>
                                <CLink :href="route('home')" class="ispace">Destaques</CLink>
                                <br/> -->
                            </p>
                        </v-col>
                        <!-- Institucional links -->
                        <v-col cols="6" sm="3" md="3" class="d-flex justify-start justify-sm-center ilinks">
                            <p><strong>Institucional</strong>
                                <br/>
                                <CLink :href="route('institucional.home')" class="ispace">Conheça-nos</CLink>
                                <br/>
                                <CLink :href="route('institucional.historia')" class="ispace">Nossa História</CLink>
                                <br/>
                                <CLink :href="route('institucional.missao')" class="ispace">Missão Visão e Valores</CLink>
                                <br/>
                                <CLink :href="route('institucional.personalizacoes')" class="ispace">Personalizações</CLink>
                                <br/>
                                <CLink :href="route('institucional.politica')" class="ispace">Política de Privacidade</CLink>
                                <br/>
                                <CLink :href="route('institucional.faq')" class="ispace">FAQ</CLink>
                            </p>
                        </v-col>
                        <!-- Newsletter -->
                        <v-col cols="12" class="d-flex justify-start align-start">
                            <c-news-letter></c-news-letter>
                        </v-col>
                    </v-row>
                </v-col>
                <!-- Right section with contact info -->
                <v-col cols="12" md="4" lg="4" class="justify-end ilinks">
                    <div>
                        <p><strong><CLink :href="route('institucional.contato')">Contatos</CLink></strong></p>
                        <br/>Alameda Tocantins, 280 Alphaville Industrial
                        <br/>06455-020 Barueri, São Paulo – Brasil
                        <br/>
                        <br/><a href="mailto:creative@creativedesign.com.br">creative@creativedesign.com.br</a>
                        <br/><a href="tel:+5501121484949">(11) 2148-4949</a>
                        <br/><a href="tel:+5501141341600">(11) 4134-1600</a>
                        <br/>Segunda a quinta-feira das 8h às 18h e
                        <br/>sexta-feira das 8h às 17h
                    </div>
                    <div class="mt-5">
                        <strong>Redes Sociais</strong>
                        <div class="d-flex flex-wrap">
                            <SocialMediaButton
                                v-for="(media, i) in mediaLinks"
                                :key="i"
                                :icon="media.ico"
                                :link="media.src"
                                class="icon-social"
                                variant="text"
                            ></SocialMediaButton>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-footer>
    <div class="copyright-section bg-primary">
        <v-container>
            <v-row>
                <v-col class="d-flex justify-center">
                    <p class="text-center">© {{ new Date().getFullYear() }} Propriedade Intelectual. Todos os direitos reservados. Desenvolvido por
                        Creative Design.</p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<style scoped>
.i-footer {
    color: white;
    flex: 1.5 1;
}

.i-footer-logo .v-img{
    margin-top: -15%;
}

.ilinks {
    font-size: 0.9rem;
    font-weight: normal;
    padding-top: 2rem;
    padding-left: 1rem;
}

.ilinks strong {
    font-size: 1.1rem;
    display: flex;
}

.ilinks a {
    color: white;
    text-decoration: none;
}

.icon-social {
    width: 30px;
    height: 30px;
    margin-right: 5px;
    margin-left: 0 !important;
}

/* Copyright section */
.copyright-section {
    padding: 10px 0;
    z-index: 1;
}

.copyright-section p {
    margin-bottom: 0;
    font-size: 0.9rem;
}

/* Responsive styles */
@media (max-width: 959px) {
    .ilinks {
        padding: 1rem 1rem 1rem 1rem;
    }

    .ilinks strong {
        font-size: 1rem;
        margin-bottom: 5px;
    }

    .ilinks p {
        font-size: 0.8rem;
    }
}

@media (max-width: 599px) {
    .i-footer {
        padding-bottom: 0;
    }

    .ilinks {
        padding: 1rem 0.5rem;
    }

    .copyright-section p {
        font-size: 0.8rem;
    }
}
</style>